var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7V13C16 13.3978 15.842 13.7794 15.5607 14.0607C15.2794 14.342 14.8978 14.5 14.5 14.5H5.5C5.10218 14.5 4.72064 14.342 4.43934 14.0607C4.15804 13.7794 4 13.3978 4 13V7",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7C16 6.60218 15.842 6.22064 15.5607 5.93934C15.2794 5.65804 14.8978 5.5 14.5 5.5H5.5C5.10218 5.5 4.72064 5.65804 4.43934 5.93934C4.15804 6.22064 4 6.60218 4 7L9.205 10.25C9.4434 10.399 9.71887 10.478 10 10.478C10.2811 10.478 10.5566 10.399 10.795 10.25L16 7Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellEmail);
export default __webpack_public_path__ + "static/media/icn_table_cell_Email.65ea6e2eced09ee525f51e4032bd9ff9.svg";
export { ForwardRef as ReactComponent };